import { createRequest, RequestConfig } from 'app/common/api';

import { TPersonData } from '../core/person';

const config: RequestConfig = {
  method: 'post',
  url: '/ws/api/update_person',
};

type UpdatedPerson = Partial<TPersonData> & { id: number };

export const updatePersonRequest = (body: UpdatedPerson) =>
  createRequest({
    url: config.url,
    method: config.method,
    body: JSON.stringify(body),
  });
